import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import HelpTip from '../HelpTip';
const tags = [
  [
    'done',
    'Done tag',
    'Added to an order after Rate Shop changes it, so you can filter those orders in ShipStation.'
  ],
  [
    'manual',
    'Manual-override tag',
    "Add this tag to an order in ShipStation and Rate Shop will leave that order alone. (Renaming it also requires editing the 'Skip when tagged RateShop Manual' rule.)"
  ],
  [
    'needsDims',
    'Needs-dimensions tag',
    'Added when an order has no weight or box size, so it cannot be priced. Fix the order in ShipStation and the tag tells you which ones.'
  ],
  [
    'error',
    'Error tag',
    'Added when ShipStation rejected the change. Open the Log for the reason.'
  ]
];
const limits = [
  [
    'lookbackHours',
    'Lookback hours',
    'How far back to look for orders still awaiting shipment. 72 = the last three days.'
  ],
  [
    'maxShipmentsPerRun',
    'Max shipments per run',
    'Safety cap on how many orders one 2-minute run may process.'
  ]
];
const SettingsDetails = ({ draft, update, disabled }) => (
  <>
    <h5>Tags in ShipStation</h5>
    <p className="small text-muted">
      These labels help you find orders that were changed, need attention or
      should be left alone.
    </p>
    <Row className="g-3 mb-4">
      {tags.map(([key, label, help]) => (
        <Col md={6} key={key}>
          <Form.Group controlId={`rate-shop-tag-${key}`}>
            <Form.Label>
              {label} <HelpTip label={label}>{help}</HelpTip>
            </Form.Label>
            <Form.Control
              disabled={disabled}
              value={draft.tags[key]}
              onChange={e =>
                update({ tags: { ...draft.tags, [key]: e.target.value } })
              }
            />
            {key === 'manual' && (
              <Form.Text>
                Renaming this tag also requires updating the “Skip when tagged
                RateShop Manual” rule.
              </Form.Text>
            )}
          </Form.Group>
        </Col>
      ))}
    </Row>
    <h5>How much to check</h5>
    <p className="small text-muted">
      Keep each run within a window and a safe order limit.
    </p>
    <Row className="g-3 mb-4">
      {limits.map(([key, label, help]) => (
        <Col md={6} key={key}>
          <Form.Group controlId={`rate-shop-${key}`}>
            <Form.Label>
              {label} <HelpTip label={label}>{help}</HelpTip>
            </Form.Label>
            <Form.Control
              type="number"
              min="1"
              max={key === 'maxShipmentsPerRun' ? 1000 : undefined}
              step={key === 'maxShipmentsPerRun' ? 1 : 'any'}
              disabled={disabled}
              value={draft.sweep[key]}
              onChange={e =>
                update({
                  sweep: {
                    ...draft.sweep,
                    [key]: e.target.value === '' ? '' : Number(e.target.value)
                  }
                })
              }
            />
          </Form.Group>
        </Col>
      ))}
    </Row>
    <h5>Keep choices made by a person</h5>
    <p className="small text-muted">
      Let the warehouse keep control when an order needs special handling.
    </p>
    <Form.Check
      id="rate-shop-human-override"
      type="switch"
      className="mb-4"
      checked={draft.respectHumanOverride}
      disabled={disabled}
      onChange={e => update({ respectHumanOverride: e.target.checked })}
      label={
        <span>
          Respect human overrides{' '}
          <HelpTip label="Respect human overrides">
            If someone changes the service in ShipStation after Rate Shop set
            it, keep their choice and do not fight back.
          </HelpTip>
        </span>
      }
    />
  </>
);
export default SettingsDetails;
